document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(
    ".shopify-section, .card, .multicolumn-card, .image-banner, .rich-text, .accordion, .footer"
  );

  items.forEach((el, index) => {
    el.classList.add("vni-reveal");
    el.style.setProperty("--vni-delay", `${Math.min(index * 70, 420)}ms`);
  });

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("vni-visible");
        }
      });
    },
    { threshold: 0.14 }
  );

  items.forEach(el => observer.observe(el));

  document.querySelectorAll(".card, .multicolumn-card, .product-card-wrapper").forEach(card => {
    card.addEventListener("mousemove", e => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty("--x", `${e.clientX - rect.left}px`);
      card.style.setProperty("--y", `${e.clientY - rect.top}px`);
    });
  });
});